import * as React from "react";
const SvgMaximize220Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18 2h-7v2h3.586l-3.793 3.793 1.414 1.414L16 5.414V9h2V2ZM5.414 16l3.793-3.793-1.414-1.414L4 14.586V11H2v7h7v-2H5.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgMaximize220Px;
